import { images } from "../../../Assets/assetsHelper";
import AddTeacherForm from "../../../Components/Organisms/Forms/AddTeacherForm/AddTeacherForm";
import "./AddTeacher.css";
import { useNavigate } from "react-router";
import {
  Card,
  CardContent,
  Typography,
  Box,
  CircularProgress,
} from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";

function AddTeacher({ Edit = false, teacher = null, loading = false, url, EditSelf = false }) {
  const navigate = useNavigate();

  return (
    <div className="mainContainer">
      <Card className="modernFormCard">
        <CardContent className="modernFormCardContent">
          <div className="formHeader">
            <div className="titleIcon">
              <PersonIcon />
            </div>
            <div className="titleContent">
              <h1>
                {Edit ? EditSelf ? "Edit My Information" : "Edit Instructor Information" : "Add New Instructor"}
              </h1>
            </div>
          </div>

          <div className="formDivider"></div>

          <Box className="modernFormWrapper">
            {loading && Edit ? (
              <div className="loadingBox">
                <CircularProgress />
              </div>
            ) : (
              <AddTeacherForm Edit={Edit} teacher={teacher} url={url} EditSelf={EditSelf} />
            )}
          </Box>
        </CardContent>
      </Card>

      {/* Modern Footer Section */}
      <div className="modernFooterSection">
        <Typography variant="body2" className="footerText">
          {Edit
            ? "Make sure all information is accurate before saving changes."
            : "Please fill in all required fields to create the instructor profile."}
        </Typography>
      </div>
    </div>
  );
}

export default AddTeacher;
